'use client';
import { isObject } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const sizesOrder = [
    'xs1',
    'xs2',
    'xs3',
    'sm1',
    'md1',
    'md2',
    'lg1',
    'xl1'
];
/**
 * Позволяет получить значение по набору семантических размерных media
 * @param defaultValue Стандартное значение, если не совпал не один из размеров
 * @param query Размерный запрос
 * @returns Значение, соответственно запросу
 *
 * @example
 * ```ts
 *  const query = responsiveSize(5, ['xl1.up', 15]);
 *  query('md1') // 5
 *  query('xl1') // 15
 *
 * ```
 */ const responsiveSize = (defaultValue, ...query)=>{
    const breakpoints = query.map((breakpoint)=>{
        const [left, right] = breakpoint[0].split('.');
        const value = breakpoint[1];
        const first = sizesOrder.indexOf(left);
        const second = sizesOrder.indexOf(right === 'up' ? sizesOrder[sizesOrder.length - 1] : right === 'down' ? sizesOrder[0] : right);
        const [from, to] = first < second ? [
            first,
            second
        ] : [
            second,
            first
        ];
        return {
            from,
            to,
            value
        };
    }).sort((a, b)=>a.from - b.from);
    return (size)=>{
        let result = defaultValue;
        for (const breakpoint of breakpoints){
            const { from, to, value } = breakpoint;
            const range = sizesOrder.slice(from, to + 1);
            if (!size && range.includes('md1')) {
                return value;
            }
            if (range.includes(size)) {
                result = isObject(result) ? _extends({}, result, value) : value;
            }
        }
        return result;
    };
};

export { responsiveSize };
//# sourceMappingURL=responsiveSize.js.map
